var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column mb-5"},[_c('div',{staticClass:"d-flex flex-column"},[_vm._l((_vm.selected.langs),function(n,i){return _c('v-card',{staticClass:"d-flex mb-10 align-center pa-5"},[_c('v-select',{staticClass:"mr-1",attrs:{"items":[
          'Ukrainian',
          'Russian',
          'English',
          'Azerbaijani',
          'Chinese',
          'Hebrew',
          'Arabic',
          'French',
          'German' ],"outlined":"","dense":"","hide-details":"","label":"Language"},model:{value:(n.name),callback:function ($$v) {_vm.$set(n, "name", $$v)},expression:"n.name"}}),_c('v-select',{staticClass:"mr-1",attrs:{"items":[
          'Pre-intermediate',
          'Intermediate',
          'Upper-intermediate',
          'Advanced',
          'Native' ],"outlined":"","dense":"","hide-details":"","label":"Experience"},model:{value:(n.exp),callback:function ($$v) {_vm.$set(n, "exp", $$v)},expression:"n.exp"}}),_c('v-btn',{attrs:{"fab":"","small":"","color":"error"},on:{"click":function($event){_vm.selected.langs = _vm.selected.langs.filter(function (n, z_i) { return z_i !== i; })}}},[_c('v-icon',[_vm._v("mdi-delete")])],1)],1)}),_c('div',{staticClass:"d-flex"},[_c('v-spacer'),_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":function($event){return _vm.selected.langs.push({
          name: '',
          exp: '',
        })}}},[_vm._v("\n        add\n        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-plus")])],1)],1)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }